import {RetailSalesReport} from "./EntityDescriptions/Documents/RetailSalesReport";
import {CashRegisterReceipts} from "./EntityDescriptions/Documents/CashRegisterReceipts";
import {RetailSettings} from "./EntityDescriptions/Catalogs/RetailSettings";
import {PurchaseOrders} from "./EntityDescriptions/Documents/PurchaseOrders";
import {ReturnOfGoodsFromVendors} from "./EntityDescriptions/Documents/ReturnOfGoodsFromVendors";
import {ReturnOfGoodsFromCustomers} from "./EntityDescriptions/Documents/ReturnOfGOodsFromCustomers";
import {IncomingBankPayments} from "./EntityDescriptions/Documents/IncomingBankPayments";
import {DistributionOfLandedCosts} from "./EntityDescriptions/Documents/DistributionOfLandedCosts";
import {StockTakings} from "./EntityDescriptions/Documents/StockTakings";
import {ActivePassiveItem} from "./EntityDescriptions/Catalogs/ACtivePassiveItem";
import {Productions} from "./EntityDescriptions/Documents/Productions";
import {GoodsTransfersOrders} from "./EntityDescriptions/Documents/GoodsTransfersOrders";
import {Deduction} from "./EntityDescriptions/Catalogs/Deduction";
import { VendorSettlementAnalytics } from "./EntityDescriptions/Catalogs/VendorSettlementAnalytics";
import {CashflowItem} from "./EntityDescriptions/Catalogs/CashflowItem";
import { CustomerSettlementAnalytics } from "./EntityDescriptions/Catalogs/CustomerSettlementAnalytics";
import {BankAccount} from "./EntityDescriptions/Catalogs/BankAccount";
import { CompanyCashBox } from "./EntityDescriptions/Catalogs/CompanyCashBox";
import {Bank} from "./EntityDescriptions/Catalogs/Bank";
import {ProductionAndSales} from "./EntityDescriptions/Documents/ProductionAndSales";
import {ProductionAndSalesWithPayments} from "./EntityDescriptions/Documents/ProductionAndSalesWithPayments";
import {Person} from "./EntityDescriptions/Catalogs/Person";
import {Imports} from "./EntityDescriptions/Documents/Imports";
import {Employee} from "./EntityDescriptions/Catalogs/Employee";
import {Position} from "./EntityDescriptions/Catalogs/Position";
import {PriceType} from "./EntityDescriptions/Catalogs/PriceType";
import {Cash} from "./EntityDescriptions/Catalogs/Cash";
import {Accrual} from "./EntityDescriptions/Catalogs/Accrual";
import {BankAccountVendorCustomer} from "./EntityDescriptions/Catalogs/BankAccountVendorCustomer";
import {BankAcquirer} from "./EntityDescriptions/Catalogs/BankAcquirer";
import {CashRegister} from "./EntityDescriptions/Catalogs/CashRegister";
import {Country} from "./EntityDescriptions/Catalogs/Country";
import {DeliveryMethod} from "./EntityDescriptions/Catalogs/DeliveryMethod";
import {Driver} from "./EntityDescriptions/Catalogs/Driver";
import {Feature} from "./EntityDescriptions/Catalogs/Feature";
import {FixedAsset} from "./EntityDescriptions/Catalogs/FixedAsset";
import {CategoryOfFixedAsset} from "./EntityDescriptions/Catalogs/CategoryOfFixedAsset";
import {Variant} from "./EntityDescriptions/Catalogs/Variant";
import {Vehicle} from "./EntityDescriptions/Catalogs/Vehicle";
import {VendorItem} from "./EntityDescriptions/Catalogs/VendorItem";
import {WithHoldingTaxRate} from "./EntityDescriptions/Catalogs/WithHoldingTaxRate";
import {AnalyticsTypeOfIncomeExpenseItem} from "./EntityDescriptions/Catalogs/AnalyticsTypeOfActivePassiveItem";
import {WorkSchedule} from "./EntityDescriptions/Catalogs/WorkSchedule";
import {TaxGroup} from "./EntityDescriptions/Catalogs/TaxGroup";
import {IncomingCashPayments} from "./EntityDescriptions/Documents/IncomingCashPayments";
import React from "react";
import { BankOpeningBalances } from "./EntityDescriptions/Documents/BankOpeningBalances";
import { CashOpeningBalances } from "./EntityDescriptions/Documents/CashOpeningBalances";
// Documents
import {CustomerInvoices} from "./EntityDescriptions/Documents/CustomerInvoices";
import {ConsumptionOrders} from "./EntityDescriptions/Documents/ConsumptionOrders";
import {ProductPricings} from "./EntityDescriptions/Documents/ProductPricings";
import {SalesOrders} from "./EntityDescriptions/Documents/SalesOrders";
import {EnterOfSettlementsBalances} from "./EntityDescriptions/Documents/EnterOfSettlementsBalances";
import {FixedAssetInitialRecognitions} from "./EntityDescriptions/Documents/FixedAssetInitialRecognitions";
import {EmployeeDismissals} from "./EntityDescriptions/Documents/EmployeeDismissals";
import {ExpenseCashPayments} from "./EntityDescriptions/Documents/ExpenseCashPayments";
import {PaymentRequests} from "./EntityDescriptions/Documents/PaymentRequests";
import {AccountingManualTransactions} from "./EntityDescriptions/Documents/AccountingManualTransactions";
import {GoodsRegardings} from "./EntityDescriptions/Documents/GoodsRegardings";
import {EmployeeHires} from "./EntityDescriptions/Documents/EmployeeHires";
import {IncomeItem} from "./EntityDescriptions/Catalogs/IncomeItem";
import {ExchangeDifferenceCalculations} from "./EntityDescriptions/Documents/ExchangeDifferenceCalculations";
import {ExpenseItem} from "./EntityDescriptions/Catalogs/ExpenseItem";
import {EmployeeTransfers} from "./EntityDescriptions/Documents/EmployeeTransfers";
import {AcquiringOperations} from "./EntityDescriptions/Documents/AcquiringOperations";
import {SalaryAccruals} from "./EntityDescriptions/Documents/SalaryAccruals";
import {CommodityWaybills} from "./EntityDescriptions/Documents/CommodityWaybills";
import {ArApWriteOffs} from "./EntityDescriptions/Documents/ArApWriteOffs";
import {ArApOffsets} from "./EntityDescriptions/Documents/ArApOffsets";
import {ExpenseBankPayments} from "./EntityDescriptions/Documents/ExpenseBankPayments";
import {DepreciationCharges} from "./EntityDescriptions/Documents/DepreciationCharges";
import {axiosApi} from "./appconst";
import {Currency} from "./EntityDescriptions/Catalogs/Currency";
import {Product} from "./EntityDescriptions/Catalogs/Product";
import {Warehouse} from "./EntityDescriptions/Catalogs/Warehouse";
import {Company} from "./EntityDescriptions/Catalogs/Company";
import {OpenBalanceOfGoods} from "./EntityDescriptions/Documents/OpenBalanceOfGoods";
import {VendorCustomer} from "./EntityDescriptions/Catalogs/VendorCustomer";
import {Contract} from "./EntityDescriptions/Catalogs/Contract";
import {Division} from "./EntityDescriptions/Catalogs/Division";
import {VendorInvoices} from "./EntityDescriptions/Documents/VendorInvoices";
import {IdentityService} from "../services/identity/IdentityService";
import {AssemblyDisassemblyOfGoods} from "./EntityDescriptions/Documents/AssemblyDisassemblyOfGoods";
import {AssemblyDIsassemblyOrders} from "./EntityDescriptions/Documents/AssemblyDisassemblyOrders";
import {TransferOfGoods} from "./EntityDescriptions/Documents/TransferOfGoods";
import {PostingOfGoods} from "./EntityDescriptions/Documents/PostingOfGoods";
import {WriteOffGoods} from "./EntityDescriptions/Documents/WriteOffGoods";
import {Unit} from "./EntityDescriptions/Catalogs/Unit";
import {Account} from "./EntityDescriptions/Accounting/Account";
import {ReferenceTypes} from "../enums/ReferenceTypes";
import {ClientBankRules} from "./EntityDescriptions/Catalogs/ClientBankRules";
import {VatTypes} from "./EntityDescriptions/Catalogs/VatTypes";
import {User} from "./EntityDescriptions/Catalogs/User";
import {Device} from "./EntityDescriptions/Catalogs/Device";
import {PosTerminal} from "./EntityDescriptions/Catalogs/PosTerminal";
import {CashierShift} from "./EntityDescriptions/Catalogs/CashierShift";
import {ConstructionObject} from "./EntityDescriptions/Catalogs/ConstructionObject";

import {FixedAssetsWriteOffs} from "./EntityDescriptions/Documents/FixedAssetsWriteOffs";
import {FixedAssetsTakeInAccounts} from "./EntityDescriptions/Documents/FixedAssetsTakeInAccounts";
import {FixedAssetsModernization} from "./EntityDescriptions/Documents/FixedAssetsModernization";
import {FixedAssetsMoving} from "./EntityDescriptions/Documents/FixedAssetsMoving";
import {FixedAssetsInventories} from "./EntityDescriptions/Documents/FixedAssetsInventories";
import {SalaryPayments} from "./EntityDescriptions/Documents/SalaryPayments";
import {SettlementVendorOpeningBalances} from "./EntityDescriptions/Documents/SettlementVendorOpeningBalances";
import {SetItemsPrices} from "./EntityDescriptions/Documents/SetItemsPrices";
import { SettlementCustomerOpeningBalances } from "./EntityDescriptions/Documents/SettlementCustomerOpeningBalances";
import {UniversalReportService} from "../services/reports/UniversalReportService";
import {ProductService} from "../services/catalogs/ProductService";
import {PaymentRequestsService} from "../services/documents/PaymentRequestsService";
import {ReturnOfGoodsFromVendorsService} from "../services/documents/ReturnOfGoodsFromVendorsService";
import {UserSettingsService} from "../services/identity/UserSettingsService";

export const AppServices = {
    Axios: axiosApi,
    IdentityService: new IdentityService(), UniversalReportService: new UniversalReportService(),
    UserSettingsService: new UserSettingsService()
};

export interface IAppEntity {
    entityType: "catalog" | "document" | "report";
    title: string;
    pluralTitle: string;
    apiUrl: string;
    isHierarchy?: boolean;
    // Group Component
    getGroupViewComponent?: (
        model: any,
        modelUpdatedEvent: (model: any) => void
    ) => React.ReactElement;
    getDetailView?: (id?: string) => React.ReactElement;
    getDetailViewComponent: (
        model: any,
        modelUpdatedEvent: (model: any) => void
    ) => React.ReactElement;
    getListView: (
        model: any,
        modelUpdatedEvent: (model: any) => void
    ) => React.ReactElement;

    // getModalView: (model: any) => any;
    getLookupComponent?: (model: any) => any;
    getDataService: () => ProductService | any;
    getEmptyModel: () => any;
    apiEnum: ReferenceTypes;
}

export const AppEntitiesCatalogs = [
    Account,
    Accrual,
    ActivePassiveItem,
    AnalyticsTypeOfIncomeExpenseItem,
    Bank,
    BankAccount,
    BankAccountVendorCustomer,
    BankAcquirer,
    Cash,
    BankOpeningBalances,
    CashRegister,
    CashflowItem,
    CashOpeningBalances,
    CashierShift,
    CategoryOfFixedAsset,
    ClientBankRules,
    CustomerSettlementAnalytics,
    Company,
    ConstructionObject,
    Contract,
    Country,
    Currency,
    Deduction,
    VendorSettlementAnalytics,
    DeliveryMethod,
    Device,
    Division,
    Driver,
    Employee,
    ExpenseItem,
    Feature,
    IncomeItem,
    Person,
    PosTerminal,
    CompanyCashBox,
    Position,
    PriceType,
    Product,
    SettlementVendorOpeningBalances,
    SettlementCustomerOpeningBalances,
    TaxGroup,
    Unit,
    User,
    Variant,
    VatTypes,
    Vehicle,
    VendorCustomer,
    VendorItem,
    Warehouse,
    WithHoldingTaxRate,
    WorkSchedule,
];

export const AppEntitiesDocuments = [
    AccountingManualTransactions,
    VendorSettlementAnalytics,
    AcquiringOperations,
    CashOpeningBalances,
    ArApOffsets,
    ArApWriteOffs,
    AssemblyDIsassemblyOrders,
    AssemblyDIsassemblyOrders,
    AssemblyDisassemblyOfGoods,
    CashRegisterReceipts,
    CommodityWaybills,
    ConsumptionOrders,
    ConsumptionOrders,
    CustomerSettlementAnalytics,
    CustomerInvoices,
    CustomerInvoices,
    DepreciationCharges,
    DepreciationCharges,
    Device,
    DistributionOfLandedCosts,
    EmployeeDismissals,
    EmployeeDismissals,
    EmployeeHires,
    EmployeeHires,
    EmployeeTransfers,
    EmployeeTransfers,
    EnterOfSettlementsBalances,
    EnterOfSettlementsBalances,
    ExchangeDifferenceCalculations,
    ExpenseBankPayments,
    BankOpeningBalances,
    ExpenseCashPayments,
    FixedAsset,
    FixedAsset,
    FixedAssetInitialRecognitions,
    FixedAssetInitialRecognitions,
    FixedAssetsInventories,
    FixedAssetsModernization,
    FixedAssetsMoving,
    FixedAssetsTakeInAccounts,
    FixedAssetsWriteOffs,
    GoodsRegardings,
    GoodsRegardings,
    GoodsTransfersOrders,
    Imports,
    Imports,
    IncomingBankPayments,
    IncomingCashPayments,
    OpenBalanceOfGoods,
    PaymentRequests,
    PostingOfGoods,
    ProductPricings,
    ProductionAndSales,
    ProductionAndSalesWithPayments,
    Productions,
    PurchaseOrders,
    RetailSalesReport,
    ReturnOfGoodsFromCustomers,
    ReturnOfGoodsFromVendors,
    SalaryAccruals,
    SalaryAccruals,
    SalaryPayments,
    SalesOrders,
    SalesOrders,
    SetItemsPrices,
    SettlementVendorOpeningBalances,
    SettlementCustomerOpeningBalances,
    StockTakings,
    StockTakings,
    TransferOfGoods,
    VendorInvoices,
    WriteOffGoods,
];

export const AppEntitiesArray = [
    Account,
    Accrual,
    ActivePassiveItem,
    AnalyticsTypeOfIncomeExpenseItem,
    User,
    ProductionAndSalesWithPayments,
    Bank,
    BankAccount,
    BankAccountVendorCustomer,
    SalaryPayments,
    BankOpeningBalances,
    VendorSettlementAnalytics,
    ProductionAndSales,
    BankAcquirer,
    Cash,
    PosTerminal,
    CompanyCashBox,
    CashierShift,
    CashRegister,
    CashflowItem,
    RetailSalesReport,
    CategoryOfFixedAsset,
    ClientBankRules,
    Company,
    ConstructionObject,
    Contract,
    CustomerSettlementAnalytics,
    Country,
    Currency,
    Deduction,
    DeliveryMethod,
    Division,
    Driver,
    SettlementVendorOpeningBalances,
    SettlementCustomerOpeningBalances,
    Employee,
    ExpenseItem,
    Feature,
    Device,
    RetailSettings,
    IncomeItem,
    Person,
    Position,
    PriceType,
    Product,
    CashRegisterReceipts,
    TaxGroup,
    CashOpeningBalances,
    Unit,
    Variant,
    Vehicle,
    VendorCustomer,
    VendorItem,
    Warehouse,
    WithHoldingTaxRate,
    WorkSchedule,
    AccountingManualTransactions,
    AcquiringOperations,
    ArApOffsets,
    ArApWriteOffs,
    AssemblyDIsassemblyOrders,
    AssemblyDisassemblyOfGoods,
    CommodityWaybills,
    ConsumptionOrders,
    CustomerInvoices,
    DepreciationCharges,
    VendorSettlementAnalytics,
    DistributionOfLandedCosts,
    EmployeeDismissals,
    EmployeeHires,
    EmployeeTransfers,
    EnterOfSettlementsBalances,
    ExchangeDifferenceCalculations,
    ExpenseBankPayments,
    ExpenseCashPayments,
    FixedAsset,
    FixedAssetInitialRecognitions,
    GoodsRegardings,
    GoodsTransfersOrders,
    Imports,
    IncomingBankPayments,
    IncomingCashPayments,
    FixedAssetsWriteOffs,
    FixedAssetsModernization,
    FixedAssetsInventories,
    FixedAssetsMoving,
    OpenBalanceOfGoods,
    PaymentRequests,
    PostingOfGoods,
    ProductPricings,
    Productions,
    SalaryAccruals,
    SalesOrders,
    SetItemsPrices,
    StockTakings,
    FixedAssetsTakeInAccounts,
    TransferOfGoods,
    VendorInvoices,
    WriteOffGoods,
];

// @ts-ignore
// export const AppEntitiesLists = [...AppEntitiesCatalogs, ...AppEntitiesDocuments];

export const AppEntities = {
    Account,
    ProductionAndSales,
    StockTakings,
    DistributionOfLandedCosts,
    Currency,
    Device,
    Company,
    ConstructionObject,
    ProductionAndSalesWithPayments,
    RetailSettings,
    Warehouse,
    CashOpeningBalances,
    BankAccount,
    Cashboxes: CompanyCashBox,
    ProductPricings,
    CashierShift,
    RetailSalesReport,
    SalaryPayments,
    IncomeItem,
    DeliveryMethod,
    PurchaseOrders,
    User,
    BankOpeningBalances,
    Feature,
    SettlementVendorOpeningBalances,
    SettlementCustomerOpeningBalances,
    ExpenseItem,
    AnalyticsTypeOfIncomeExpenseItem,
    VendorItem,
    WorkSchedule,
    VatTypes,
    SalesOrders,
    Bank,
    GoodsTransfersOrders,
    CustomerSettlementAnalytics,
    VendorInvoices,
    CashRegisterReceipts,
    AccountingManualTransactions,
    Accrual,
    Productions,
    BankAccountVendorCustomer,
    Vehicle,
    DepreciationCharges,
    Position,
    SalaryAccruals,
    GoodsRegardings,
    BankAcquirer,
    Person,
    Cash,
    PaymentRequests,
    Driver,
    ReturnOfGoodsFromVendors,
    VendorSettlementAnalytics,
    CashflowItem,
    Employee,
    ReturnOfGoodsFromCustomers,
    PriceType,
    Variant,
    VendorCustomer,
    Contract,
    Division,
    Product,
    Unit,
    FixedAsset,
    CustomerInvoices,
    AssemblyDIsassemblyOrders,
    EmployeeHires,
    ExchangeDifferenceCalculations,
    AcquiringOperations,
    ActivePassiveItem,
    ArApOffsets,
    ArApWriteOffs,
    AssemblyDisassemblyOfGoods,
    CashRegister,
    CategoryOfFixedAsset,
    ClientBankRules,
    CommodityWaybills,
    ConsumptionOrders,
    Country,
    Deduction,
    EmployeeDismissals,
    EmployeeTransfers,
    EnterOfSettlementsBalances,
    ExpenseBankPayments,
    ExpenseCashPayments,
    FixedAssetInitialRecognitions,
    Imports,
    IncomingBanks: IncomingBankPayments,
    IncomingCashs: IncomingCashPayments,
    FixedAssetsInventories,
    FixedAssetsWriteOffs,
    FixedAssetsModernization,
    FixedAssetsMoving,
    OpenBalanceOfGoods,
    PostingOfGoods,
    TaxGroup,
    PosTerminal,
    FixedAssetsTakeInAccounts,
    SetItemsPrices,
    TransferOfGoods,
    WithHoldingTaxRate,
    WriteOffGoods,
};
